import { IAdapter } from './interfaces';
import { ConsoleAdapter } from './ConsoleAdapter';

export class LoggerService {
  private adapter!: IAdapter; // FYI: adding "definite assignment assertion" since init is called in constructor and init always sets adapter

  constructor() {
    this.init();
  }

  public init() {
    this.adapter = new ConsoleAdapter();
  }

  public debug(message: string, contexts?: any) {
    this.log('debug', message, contexts);
  }

  public warn(message: string, contexts?: any) {
    this.log('warning', message, contexts);
  }

  public error(message: string, contexts: any) {
    this.log('error', message, contexts);
  }

  public log(level: string, message: string, contexts: any) {
    this.adapter.log(level, message, contexts);
  }
}

export const Logger = new LoggerService();
